export enum SeatLimitsNotificationEntity {
  ApiKey = "API key",
  User = "user",
}
